export default {
  budget: null,
  createdDate: null,
  creditAppDeals: [],
  creditType: null,
  creditVerification: {
    verified: false,
    verifiedDate: null
  },
  dealDetails: {},
  dealNotifications: {},
  dealType: null,
  downPayment: null,
  downPaymentPercent: null,
  downPaymentType: null,
  hasSessionWalletChange: false,
  hasPreviousPaymentInfo: false,
  icoTradeIn: {},
  interestRate: {},
  interactions: {
    autoFilledListing: {},
    disableBudgetCalculationAlert: false,
    disableComparePopover: false,
    disablePaymentPopover: false,
    hasBudgetInteraction: false,
    hasOpenedTradeIn: false,
    hasOpenedWallet: false,
    hasRequestedTaxesFees: false,
    hasUpdatedCreditOrTerm: false,
    hasUpdatedNDSCalc: false,
    hasUpdatedPaymentOption: false,
    hasUpdatedWallet: false,
    hasWalletInteractionWithinVDP: false,
    hideReceipt: [],
    paymentEmphasis: false,
    useFallbackLead: false
  },
  isLoading: false,
  isPaymentsInfoLoaded: false,
  lastUpdated: null,
  leaseMileageRange: null,
  leaseTerm: null,
  listingCashPayments: {},
  listingIncentives: {},
  listingLeasePayments: {},
  listingPayments: {},
  loanTerm: null,
  monthlyBudget: null,
  myWallet: {
    configs: {},
    displayModal: false,
    displayWalletErrorMessage: false,
    hideBackButton: false,
    listingCategory: null,
    listingId: null,
    selectedPanelName: null,
    showPaymentDetailsModal: false,
    showPencilingPayments: false
  },
  paymentOption: 'finance',
  penciling: {
    customLender: {},
    icoTradeInOffer: null,
    offerPrice: null,
    penciledVdpListings: [],
    pencilingPayments: {}
  },
  previousPaymentInfo: {},
  timeStamp: null,
  tradeIn: {
    amountOwed: null,
    condition: null,
    ico: [],
    source: null,
    value: null
  },
  walletId: null,
  zip: null
};